export default "__VITE_ASSET__6n6qlndD__"